module.exports = __webpack_public_path__ + "static/media/resync.3494022d.svg";